export type ISaveFormViaAjax = (
  form: HTMLFormElement | JQuery<HTMLFormElement>,
  validate?: boolean,
  pushHistory?: boolean,
  silent?: boolean,
  create?: boolean,
  messages?: { successMsg?: string; errorMsg?: string }
) => JQuery.Deferred<IDCA.IPostResponse>;

export function _saveFormViaAjax(
  form: HTMLFormElement | JQuery<HTMLFormElement>,
  validate = false,
  pushHistory = false,
  silent = false,
  create = true,
  messages?: { successMsg?: string; errorMsg?: string }
): JQuery.Deferred<IDCA.IPostResponse> {
  const userOptions = window.DexeroCoreApp.getUserOptions();
  const { langObj = {} } = userOptions;
  const dfd = new ($ as any).Deferred();
  const $form = $(form);
  const $directionInput = $form.find('input[name="direction"]');
  const $partialSaveInput = $form.find('input[name="partialSave"]');
  const suffix = $form.data('suffix');
  // We need to disable direction, and partial save so they are not included in the formData
  $directionInput.prop('disabled', true);
  if (!create) {
    $partialSaveInput.prop('disabled', true);
  }
  const formData = new FormData($form[0] as any);

  const action = $form.attr('action') as string;
  const $uuidInput = $form.find('input[name="uuid"]');
  const dataEntryExists = !!$uuidInput.val();
  const currentUrl = window.location.href;
  const hasUuidParam = window.DexeroCoreApp.getUuidValueInUrl(currentUrl) !== null;
  const postUrl = `${action}${window.DexeroCoreApp.getUrlSeperator(action)}ajax=true&partialSave=${
    validate ? 'false' : 'true'
  }${!create ? '&direction=saveAndReload' : ''}`;

  // Messages
  const toastSuccessMsg = messages?.successMsg || langObj.successCompletionMsgText;
  const toastErrorMsg = messages?.errorMsg || langObj.errorText;

  // Re-enable fields
  $directionInput.prop('disabled', false);
  if (!create) {
    $partialSaveInput.prop('disabled', false);
  }

  function postForm() {
    // console.log('postUrl: ', postUrl);
    // console.log('formData: ', formData);

    // for (var pair of Array.from(formData.entries())) {
    //   console.log(pair[0] + ', ' + pair[1]);
    // }

    // var res = Array.from(formData.entries(), ([key, prop]) => ({
    //   [key]: {
    //     ContentLength: typeof prop === 'string' ? prop.length : prop.size,
    //   },
    // }));

    // console.log('res: ', res);
    // console.log('****************');

    return $.ajax({
      cache: false,
      contentType: false,
      data: formData,
      processData: false,
      timeout: 90000,
      type: 'POST',
      url: postUrl,
      error(jqXHR, textStatus) {
        if (textStatus === 'timeout' && !silent) {
          window.DexeroCoreApp.userToastMsg('error', toastErrorMsg, '');
        }
      },
    });
  }

  function injectUuid(responseData: IDCA.IPostResponse) {
    const uuid = responseData.newDataBundleUUID;
    if (!dataEntryExists && uuid) {
      $uuidInput.val(uuid);
      if (!hasUuidParam && pushHistory) {
        window.history.pushState(
          {},
          '',
          `${currentUrl}${window.DexeroCoreApp.getUrlSeperator(currentUrl)}uuid=${uuid}`
        );
      }
    }
  }

  // If we don't need to validate the form, we can just post it
  if (!validate) {
    postForm().done((responseData) => {
      injectUuid(responseData);
      if (!silent) {
        if (responseData.success !== 'true') {
          window.DexeroCoreApp.userToastMsg('error', toastErrorMsg, '');
        } else {
          window.DexeroCoreApp.userToastMsg('success', toastSuccessMsg, '');
        }
      }
      dfd.resolve(responseData);
    });
  } else if ($form.valid()) {
    // If we do want validation
    postForm().done((responseData) => {
      injectUuid(responseData);
      if (responseData.success !== 'true') {
        if (!silent) {
          window.DexeroCoreApp.userToastMsg('error', toastErrorMsg, '');
        }
        window.DexeroCoreApp.displayJsonErrors(responseData.formError, suffix);
        ($form as any).find('.form-group.has-error').first().scrollTo(-20, true);
        dfd.reject(responseData);
      } else {
        if (!silent) {
          window.DexeroCoreApp.userToastMsg('success', toastSuccessMsg, '');
        }
        dfd.resolve(responseData);
      }
    });
  } else {
    dfd.reject({ success: 'false' });
  }
  return dfd.promise();
}
